"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _excluded = ["children", "theme", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative',
      boxShadow: 'none',
      backgroundColor: theme.palette.background.appBar
    }
  };
});

var PresetAppBar = function PresetAppBar(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], _extends({
    className: (0, _classnames["default"])(classes.root, className)
  }, other), children));
};

PresetAppBar.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  theme: _propTypes["default"].object
};
PresetAppBar.defaultProps = {
  children: '',
  className: ''
}; // prettier-ignore

var _default = PresetAppBar;
exports["default"] = _default;